/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../components/AlertDialog";
import { useNavigate } from "react-router-dom";
export default function Users(props) {
  const { api } = useContext(FirebaseContext);
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
    updateProfile,
  } = api;
  const [state, setState] = useState({
    userType: "practiceadmin",
    firstName: "",
    lastName: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });

  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  useEffect(() => {
    if (usersdata.users ) {
      setData(
        usersdata.users.filter(
          (user) =>
            (user.userType === "practiceadmin" &&
               auth.info.profile.practiceNumber === user.practiceNumber) //||
            // (user.userType === "nurse" &&
            //   auth.info.profile.practiceNumber === user.practiceNumber)
        )
      );
        } else {
     
   
      setData([]);
    }
  }, [auth.info.profile.practiceNumber, usersdata.users]);
  useEffect(() => {
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }

      setSpecialityTypes(obj);
    }
  }, []);

  // useEffect(() => {
  //   if (auth.info && auth.info.profile) {
  //     setIsdepData({
  //       isIndependent: false,
  //     });
  //   }
  // }, [auth.info]);
  // console.log("this is data", data);
  const columns = [
    { title: language.first_name, field: "firstName", initialEditValue: "" },
    { title: language.last_name, field: "lastName", initialEditValue: "" },
    // { title: "Private Practice Number", field: "privatePracticeNumber", initialEditValue: "" },
    { title: "Practice Name", field: "practiceName", initialEditValue: "" },
    {
      title: "Department",
      field: "specialityType",
      lookup: specialityTypes,
    },
    {
      title: language.email,
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
    },
    { title: "password", field: "password", initialEditValue: "" },
    {
      title: language.mobile,
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },
    {
      title: "Private Practice",
      field: "privatePractice",
      type: "boolean",
      initialEditValue: true,
    },
    {
      title: language.account_approve,
      field: "practiceAdminActiveStatus",
      type: "boolean",
      initialEditValue: true,
    },
  ];
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    ((
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    ),
    (
      <MaterialTable
        title={"Practice Admins"}
        columns={columns}
        data={data}
        options={{
          exportButton: true,
          sorting: true,
          actionsColumnIndex: -1,
        }}
        editable={{
          onRowAdd: (newData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.users && res.users.length > 0) {
                    alert(language.user_exists);
                    reject();
                  } else if (res.error) {
                    alert(language.email_or_mobile_issue);
                    reject();
                  } else {
                    newData["createdByAdmin"] = true;
                    newData["userType"] = "practiceadmin";
                    newData["createdAt"] = new Date().toISOString();
                    newData["referralId"] =
                      newData.firstName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    setState({
                      ...state,
                      newData,
                    });
                    let role = auth.info.profile.userType;
                    if (role === "practiceadmin") {
                      newData["practiceadmin"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "nurse") {
                      newData["nurse"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "doctor") {
                      newData["doctor"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    }

                    emailSignUp(newData).then((res) => {
                      resolve();
                      // console.log("i am the back data", res);
                      if (res.uid) {
                        setTimeout(() => {
                          setCommonAlert({
                            open: true,
                            msg: language.account_create_successfully,
                          });
                          navigate("/login");
                          // console.log(newData);
                        }, 3000);
                      } else {
                        setCommonAlert({
                          open: true,
                          msg: language.reg_error,
                        });
                      }
                    });
                  }
                });
              }, 600);
            }),

          onRowUpdate: (newData, oldData) =>
            new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, newData));
              }, 600);
            }),
          onRowDelete: (oldData) =>
            features.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(language.demo_mode);
                  }, 600);
                }),
        }}
      />
    ))
  );
}
